<div *ngIf="item.allowed_types.length > 1">
  <label [for]="item.name">{{'select_type'| translation}}<span *ngIf="item.required">*</span></label>
  <nb-form-field>
    <nb-select
      [(ngModel)]="type"
      [placeholder]="'select_type'| translation"
      (selectedChange)="getDataItems(type)"
      [required]="item.required"
      [disabled]="checkDisable()"
      fullWidth="true">

      <nb-option
        *ngFor="let key of item.allowed_types"
        [value]="key.name">
        {{key.name}}
      </nb-option>
    </nb-select>
  </nb-form-field>

  <nb-form-field
    *ngIf="type && type.length > 0">
    <label
      [for]="item.name">
      {{item.translation_key||item.label || 'select_item'| translation|translationFromString | transformText :item?.text_transform}}
      <span *ngIf="item.required">*</span>
    </label>

    <nb-select
      [(ngModel)]="value"
      [placeholder]="item.translation_key||item.label || 'select_item'| translation"
      (componentUpdated)="triggerUpdate($event)"
      [required]="item.required"
      [disabled]="checkDisable()"
      fullWidth="true">

      <nb-option
        *ngIf="item.allow_new"
        [value]="new">
        New
      </nb-option>
      <nb-option
        *ngFor="let key of dataItems"
        [value]="key.data[ite.value_key || 'id']">
        {{getTitle(key.data)}}
      </nb-option>
    </nb-select>
  </nb-form-field>
</div>

<div *ngIf="item.allowed_types.length == 1">
  <nb-form-field
    style="margin: 10px 0;"
    *ngIf="(dataItems && dataItems.length > 0) || item.allow_new">
    <label
      [for]="item.name">
      {{item.translation_key|| item.label || 'select_item'| translation}}
      <span *ngIf="item.required">*</span>
    </label>
    <nb-select
      [(ngModel)]="value"
      [placeholder]="item.translation_key||item.label || 'select_item'| translation"
      (selectedChange)="setConnectionData($event,item.setting,'id')"
      [required]="item.required"
      #connectSelect [disabled]="checkDisable()"
      fullWidth="true">
      <nb-option
        *ngIf="item.allow_new"
        [value]="new">
        New
      </nb-option>
      <nb-option
        *ngFor="let key of dataItems"
        [value]="getDataValue(key)">
        {{getTitle(key.data)}}
      </nb-option>
    </nb-select>
    <span
      nbSuffix
      *ngIf="item.helpText"
      nbTooltip="{{item.helpText}}">
      <i class="fas fa-question-circle"></i>
    </span>
  </nb-form-field>
</div>
<div>
    <app-view
      [info]="childview[0]"
      *ngIf="childview && childview[0] && childview[0].data"
      [items]="childview[0].data.content"
      [data]="data"
      (openViewHandler)="openViewHandler($event, ite)"
      (moveHandler)="openMove()"
      (openLinkHandler)="openLinkHandler($event, ite)">
    </app-view>
    {{childview}}
</div>
